import React from "react";
import { Routes, Route } from "react-router-dom";
import Home from "./pages/Home";
import Product from "./pages/Product";
import Login from "./pages/Login";
import Signup1 from "./pages/Signup1";
import Signup2 from "./pages/Signup2";
import SingleProduct from "./pages/SingleProduct";
import CartPage from "./pages/Cart";
import Signup3 from "./pages/Signup3";
import Verify from "./pages/VerifyEmail";
import GetUser from "./component/GetUUser";
import GetBooks from "./component/handleGetProduct";
import Search from "./pages/Search";
import OrderTrackingPage from "./pages/Order";
import About from "./pages/About";
import ProtectedRoute from "./component/ProtectedRoute";
import TermsOfService from "./pages/termsOfService";

function App() {
  return (
    <Routes>
      <Route element={<GetUser />}>
        <Route element={<GetBooks />}>
          <Route index element={<Home />} />
          <Route path="/product/:cat" element={<Product />} />
          <Route path="/search/:s" element={<Search />} />
          <Route path="/single/:id" element={<SingleProduct />} />
          <Route path="/about" element={<About />} />
          <Route path="/termsofservice" element={<TermsOfService />} />
          <Route element={<ProtectedRoute />}>
            <Route path="/cart" element={<CartPage />} />
            <Route path="/order" element={<OrderTrackingPage />} />
          </Route>
        </Route>
      </Route>
      <Route path="/verify" element={<Verify />} />
      <Route path="/login" element={<Login />} />
      <Route path="/signup1" element={<Signup1 />} />
      <Route path="/signup2" element={<Signup2 />} />
      <Route path="/signup3" element={<Signup3 />} />
    </Routes>
  );
}

export default App;
